export const ENV = 'prod'
export const baseURL = 'https://api.ciitizen.com' // prod url for now
export const appURL = 'https://app.ciitizen.com'
export const personaCfg = {
  env: 'production',
  templateId: 'tmpl_1YHzJKbR57y8ks7cBDg2YbcA'
}
export const patientBffBaseURL = 'https://pdn-patient-bff.ce.prd.locusdev.net/api/'
